import { AUTHENTICATE_USER, LOGOUT } from "./actionTypes";

export const loginUser = user => ({
    type: AUTHENTICATE_USER,
    user
});

export const logout = () => ({
    type: LOGOUT
});